import { render, staticRenderFns } from "./ProjectShowSubmitalList.vue?vue&type=template&id=6556e37c&scoped=true&"
import script from "./ProjectShowSubmitalList.vue?vue&type=script&lang=js&"
export * from "./ProjectShowSubmitalList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectShowSubmitalList.vue?vue&type=style&index=0&id=6556e37c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6556e37c",
  null
  
)

export default component.exports